import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { getParentProduct } from '../utils/index.tsx';

export const useParentProduct = () => {
	const { data } = useProjectContext();
	const projectType = data?.projectType;
	return getParentProduct(projectType);
};
